import { trackMeasurement } from "@/analytics/track";

import type { CallContext } from "./requestHelper";

export abstract class BaseRpcBackend<T> {
  private callIndex = 0;
  private callMap: Record<number, string> = {};

  constructor(private transport: "nats" | "http") {}

  get calls(): string[] {
    return Object.values(this.callMap);
  }

  async callBackend(context: CallContext): Promise<T> {
    const index = ++this.callIndex;
    try {
      this.callMap[index] = context.path;
      const startTime = performance.now();
      const response = await this.doCallBackend(context);
      trackMeasurement({
        type: "rpc_" + context.path,
        values: { elapsedTimeMs: performance.now() - startTime },
        context: { transport: this.transport },
      });
      return response;
    } finally {
      delete this.callMap[index];
    }
  }

  abstract doCallBackend(context: CallContext): Promise<T>;
}
